import {ProgressBar} from '@sollapay/ui/components';
import {formatNIS, parseMoney, Percent} from '@sollapay/utils';

import {AssetTrustProgressLegend} from './AssetTrustProgressLegend';
import {AssetTrustProgressSummary} from './AssetTrustProgressSummary';

import type {FC} from 'react';

export interface AssetTrustProgressProps {
  purchasePriceNis: string;
  /** Already the outstanding balance (`StandardTrustType.computeAmountDue`), not a total — use as-is, never subtract deposit from it again. */
  amountToPayNis: string;
  depositPaidNis: string;
}

/** Percent is deposit-over-purchase-price — only correct while the caller collects 100% of the price (true for GENERAL_SALE, this card's only consumer today). */
export const AssetTrustProgress: FC<AssetTrustProgressProps> = ({
  purchasePriceNis,
  amountToPayNis,
  depositPaidNis
}) => {
  const percent = Percent.from(parseMoney(depositPaidNis).toPercentOf(purchasePriceNis))
    .clamp(0, 100)
    .toNumber();
  const purchasePriceFormatted = formatNIS(purchasePriceNis);
  const depositPaidFormatted = formatNIS(depositPaidNis);
  const amountToPayFormatted = formatNIS(amountToPayNis);

  return (
    <div className="flex flex-col">
      <AssetTrustProgressSummary
        purchasePriceFormatted={purchasePriceFormatted}
        depositPaidFormatted={depositPaidFormatted}
        percent={percent}
      />
      <ProgressBar value={percent} className="mt-2" aria-hidden />
      <AssetTrustProgressLegend
        depositPaidFormatted={depositPaidFormatted}
        amountToPayFormatted={amountToPayFormatted}
        className="mt-3"
      />
    </div>
  );
};
